import React, { useState, useCallback } from 'react';
import { navigate } from 'gatsby';

import { Card, className } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';

export default function CardComponent({
    button,
    colorScheme,
    textNode,
    title,
    typeStyle
}) {
    const [hover, setHover] = useState(false);
    const [active, setActive] = useState(false);

    const onClick = useCallback(() => {
        setActive(true);

        if (button.link && button.link.slug) {
            return navigate(`/${button.link.slug}/`);
        }

        window.location.href = button.externalLink;
    }, [button.link, button.externalLink]);

    const onMouseEnter = useCallback(() => {
        setHover(true);
    }, []);

    const onMouseLeave = useCallback(() => {
        setHover(false);
    }, []);

    return (
        <Card
            wrapperClassName={`${style.card} ${colorScheme ? colorStyle[`bg-dark--${colorScheme}`] : ''
                } ${colorScheme ? colorStyle[`before-dark--${colorScheme}`] : ''} ${typeStyle ? style.styleC : ""}`}
            bodyClassName={`text-center ${style['card__body']}`}
            title={title}
            titleHref={
                button.link?.slug
                    ? `/${button.link.slug}/`
                    : button.externalLink
                        ? button.externalLink
                        : null
            }
            titleClassName={style.cardHeading}
            text={textNode?.contentWithoutWrapper}
            textClassName={`body mb-7 ${style.text}`}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {button ? (
                <div className={style['card__button-wrapper']}>
                    <ButtonComponent
                        buttonClassName={style['card__button']}
                        dark={true}
                        button={{
                            ...button,
                            detached: false,
                            block: true,
                            active,
                            hover,
                        }}
                    />
                </div>
            ) : null}
        </Card>
    );
}
